var Haiku = require("@haiku/core");
module.exports = {
  metadata: {
    uuid: "67a900ef-ed0f-491d-bee4-d8a023cf6ea0",
    version: "0.0.1",
    organization: "Tina",
    project: "AnimatorWebsiteIcon2",
    branch: "master",
    folder: "/Users/agustina/.haiku/projects/Tina/AnimatorWebsiteIcon2",
    username: "tina@haiku.ai",
    root: "https://cdn.haiku.ai/9fec979d-d44c-4994-b16b-ee78d60c5e95/5f95a2978fb21498c9f76103836200625255c63b/",
    core: "4.5.0",
    title: "Deco3",
    type: "haiku",
    relpath: "code/deco3/code.js"
  },
  options: {},
  states: {},
  eventHandlers: {},
  timelines: {
    Default: {
      "haiku:Deco3-0c407b0457d72f75": {
        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
        "style.position": "relative",
        "style.overflowX": "visible",
        "style.overflowY": "visible",
        "sizeAbsolute.x": 9,
        "sizeAbsolute.y": 9,
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeMode.z": 1
      },
      "haiku:e52175b974ac": {
        "sizeAbsolute.y": 9,
        "style.position": "absolute",
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 9,
        "sizeMode.x": 1,
        "style.margin": "0",
        "sizeMode.y": 1,
        "translation.x": 4.5,
        "translation.y": 4.5,
        "style.zIndex": 5,
        "rotation.z": {
          "0": { value: 0, edited: true, curve: "linear" },
          "667": { value: 6.284 }
        }
      },
      "haiku:672a0beeee34": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:29bc7be5d93c": {
        fill: "#04B6CB",
        "translation.x": -54,
        "translation.y": -16
      },
      "haiku:f7272cb855f6": {
        x: 55.4146654,
        y: 17.7146654,
        width: 5.94212411,
        height: 5.94212411,
        rx: 1,
        "translation.x": 5.009919,
        "translation.y": 52.115261,
        "rotation.z": 5.410521
      }
    }
  },
  template: {
    elementName: "div",
    attributes: {
      "haiku-id": "Deco3-0c407b0457d72f75",
      "haiku-title": "Deco3"
    },
    children: [
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "e52175b974ac",
          "haiku-title": "deco3",
          "haiku-source":
            "designs/AnimatorWebsiteIcon2.sketch.contents/slices/deco3.svg"
        },
        children: [
          {
            elementName: "g",
            attributes: {
              "haiku-id": "672a0beeee34",
              "haiku-title": "Page-1",
              id: "c008d085398b"
            },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "29bc7be5d93c",
                  "haiku-title": "HaikuCore-icon",
                  id: "9d17eb90600f"
                },
                children: [
                  {
                    elementName: "rect",
                    attributes: {
                      "haiku-id": "f7272cb855f6",
                      "haiku-title": "deco3",
                      id: "29aa99b68293"
                    },
                    children: []
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@haiku/tina-animatorwebsiteicon2/code/deco3/code.js
// module id = 434
// module chunks = 35783957827783